import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { IAgentDetail, ICustomClaims } from '@app/models';
import { AgentViewType } from '@app/pages/authManager/dialogs/addAgent.dialog';
import { Table, TableBody, TableHead, TableRow, TableCell } from '@material-ui/core';
import { PasslyButton } from '@app/components';
import { defaultClaimsMapping } from '@app/helpers';
import { renderReadOnlyRows } from './openIDConnectConfig.component';

interface IProps {
    editAgentCallback: Function;
    agent: IAgentDetail;
};

const ReadOpenIDConnectConfig: React.SFC<IProps> = ({ editAgentCallback, agent }) => {
    const { translation } = useTypedTranslation();

    const config = JSON.parse(agent.Configuration);
    const customClaimsMapping: ICustomClaims = config.CustomClaimsMapping === null || config.CustomClaimsMapping === undefined ? 
        { Entries: [] }
        :
        JSON.parse(config.CustomClaimsMapping) as ICustomClaims;

    return (
        <div className='detailPage__section'>
            <div className='detailPage__section-head'>
                {translation('OIDC_CONFIGURATION_TAB')}
            </div>
            <div className='detailPage__section-content'>
                <PasslyButton id='editAgentLink' onClick={() => editAgentCallback(AgentViewType.editAgentExtendedView)}>{translation('EDIT')}</PasslyButton>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{translation('OIDC_CLAIM_VALUE')}</TableCell>
                            <TableCell></TableCell>
                            <TableCell>{translation('OIDC_CLAIM_NAME')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <>
                            {defaultClaimsMapping.map((item, index) => (
                                renderReadOnlyRows(item, index)
                            ))}
                        </>
                        <>
                            {customClaimsMapping?.Entries?.length > 0 && customClaimsMapping.Entries.map((item, index) => (
                                renderReadOnlyRows(item, index)
                            ))
                            }
                        </>
                    </TableBody>
                </Table>
            </div>
        </div>
    );
};

export default ReadOpenIDConnectConfig;